import { createContext, use } from 'react';

import { useOidcUser } from '@axa-fr/react-oidc';

import { Permission } from '@repo/api/auth';
import { SingleUser } from '@repo/api/users.types';

export type PermissionOverrides = { [k in Permission]?: boolean | null };

export type User = SingleUser & {
	permissions: Permission[] & {
		override: (name: Permission) => void;
		overrides: PermissionOverrides;
		overridesActive: boolean;
		reset: () => void;
		toggleActive: () => void;
	};
};

export const UserContext = createContext<User | undefined>(undefined);

export const useUser = () => {
	const context = use(UserContext);
	if (!context) {
		throw new Error('useUser must be used within a UserContext');
	}
	return context;
};

export const useUserLoadingState = () => {
	const { oidcUserLoadingState } = useOidcUser();

	return oidcUserLoadingState;
};
